import { PdfViewerAnnotation } from '@sequencehq/pdf-viewer'
import { ContractField } from '../../../../types'

const isPdfViewerAnnotation = (obj: any): obj is PdfViewerAnnotation =>
  obj && 'id' in obj

export const contractFieldsToAnnotations = ({
  fields,
  /**
   * Gemini bounding box coordinates are based on a 1000x1000 grid.
   */
  referenceCoordinates = {
    width: 1000,
    height: 1000
  }
}: {
  fields: ContractField[]
  referenceCoordinates: {
    width: number
    height: number
  }
}): PdfViewerAnnotation[] => {
  return fields
    .map(field => {
      /**
       * Assumptions:
       * - `boundingPoly` contains exactly 4 vertices, otherwise it's filtered out
       * - the vertices are ordered top left, top right, bottom right, bottom left
       */
      if (!field.boundingPoly || field.boundingPoly.vertices.length !== 4) {
        return
      }

      const { width: pageWidth, height: pageHeight } = referenceCoordinates

      const [topLeft, topRight, , bottomLeft] = field.boundingPoly.vertices

      /**
       * We don't return a full 'bounding box' for our annotations as they can
       * be a smidge inaccurate. We instead create a 16px dot to roughly indicate
       * the position of the field on the page. This should be combined with the
       * 'circle' highlight style.
       */
      const xMidpoint = topLeft.x + (topRight.x - topLeft.x) / 2
      const yMidpoint = topLeft.y + (bottomLeft.y - topLeft.y) / 2
      return {
        id: field.fieldPath,
        pageNumber: field.boundingPoly.pageNumber - 1,
        top: clampedToPercentage(yMidpoint / pageHeight),
        left: clampedToPercentage(xMidpoint / pageWidth),
        width: '1px',
        height: '1px'
      }
    })
    .filter(isPdfViewerAnnotation)
}

const clampedToPercentage = (value: number): string => {
  return `${value * 100}%`
}
